export default class FlipCards {
    constructor(card) {
        this.card = card
        this.front = this.card.querySelector('.card-front')
        this.back = this.card.querySelector('.card-back')

        this.dragThreshold = 12
        this.isPointerDown = false
        this.hasDragged = false
        this.blockNextClick = false
        this.startX = 0
        this.startY = 0

        this.init()
    }

    init() {
        this.pointerDownHandler = this.handlePointerDown.bind(this)
        this.pointerMoveHandler = this.handlePointerMove.bind(this)
        this.pointerUpHandler = this.handlePointerUp.bind(this)
        this.clickHandler = this.handleClick.bind(this)
        this.keydownHandler = this.handleKeyDown.bind(this)

        this.card.addEventListener('pointerdown', this.pointerDownHandler)
        this.card.addEventListener('pointermove', this.pointerMoveHandler)
        this.card.addEventListener('pointerup', this.pointerUpHandler)
        this.card.addEventListener('pointercancel', this.pointerUpHandler)
        this.card.addEventListener('click', this.clickHandler)
        this.card.addEventListener('keydown', this.keydownHandler)
    }

    handlePointerDown(event) {
        if (typeof event.button === 'number' && event.button !== 0) return

        this.isPointerDown = true
        this.hasDragged = false
        this.startX = event.clientX
        this.startY = event.clientY
    }

    handlePointerMove(event) {
        if (!this.isPointerDown || this.hasDragged) return

        const deltaX = Math.abs(event.clientX - this.startX)
        const deltaY = Math.abs(event.clientY - this.startY)

        if (deltaX > this.dragThreshold || deltaY > this.dragThreshold) {
            this.hasDragged = true
        }
    }

    handlePointerUp() {
        this.isPointerDown = false

        if (this.hasDragged) {
            this.blockNextClick = true
            window.setTimeout(() => {
                this.blockNextClick = false
            }, 0)
        }
    }

    handleClick(event) {
        if (this.blockNextClick) {
            event.preventDefault()
            return
        }

        this.toggle()
    }

    handleKeyDown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return

        event.preventDefault()
        this.toggle()
    }

    toggle(forceState) {
        const isFlipped = typeof forceState === 'boolean'
            ? forceState
            : !this.card.classList.contains('is-flipped')

        this.card.classList.toggle('is-flipped', isFlipped)
        this.card.setAttribute('aria-pressed', isFlipped ? 'true' : 'false')

        if (this.front) {
            this.front.setAttribute('aria-hidden', isFlipped ? 'true' : 'false')
        }

        if (this.back) {
            this.back.setAttribute('aria-hidden', isFlipped ? 'false' : 'true')
        }
    }

    destroy() {
        this.card.removeEventListener('pointerdown', this.pointerDownHandler)
        this.card.removeEventListener('pointermove', this.pointerMoveHandler)
        this.card.removeEventListener('pointerup', this.pointerUpHandler)
        this.card.removeEventListener('pointercancel', this.pointerUpHandler)
        this.card.removeEventListener('click', this.clickHandler)
        this.card.removeEventListener('keydown', this.keydownHandler)
    }

    static init() {
        FlipCards.items = Array.from(document.querySelectorAll('[data-flip-card]')).map(
            (card) => new FlipCards(card),
        )
    }
}